export default {
    log(msg) {
        console.log(msg);
    }
}



// WEBPACK FOOTER //
// ./src/log/index.js